export const handleError = (error) => {
	if (error?.response?.data?.message) {
		return error.response.data;
	}
	return { message: error?.message || "Something went wrong" };
};
